import { useState } from 'react';

import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
// import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import LogOutIcon from '@assets/images/log-out.svg?url';
import LogOutIconHover from '@assets/images/log-out-active.svg?url';
import { useStyles } from './styles/ProfilePopover.styles';
import { UserAvatar } from './UserAvatar';
import { logout } from '@features/redux/store';

// const HELP_CENTER_URL = 'https://help-center-login.moutfitters.com';

interface ProfilePopoverProps {
    anchorEl: any;
    onClose: () => void;
}

export const ProfilePopover = ({ anchorEl, onClose }: ProfilePopoverProps) => {
    const classes = useStyles();

    const [hover, setHover] = useState<boolean>(false);

    const handleLogout = () => logout();
    // const handleHelpCenter = () => window.open(HELP_CENTER_URL, '_blank');

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            className={classes.wrapper}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}>
            <div className={classes.userInfo} onClick={onClose}>
                <div className={classes.itemContainer}>
                    <UserAvatar toggled={true} handleToggleProfile={onClose} />
                </div>

                {/* <div className={classes.itemContainer} onClick={handleHelpCenter}>
                    <div className={classes.icon}>
                        <HelpOutlineIcon sx={{ color: '#444' }} />
                    </div>

                    <Typography>Help Center</Typography>
                </div> */}

                <div
                    className={classes.itemContainer}
                    onMouseOver={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    onClick={handleLogout}>
                    <div className={classes.icon}>
                        <img src={hover ? LogOutIconHover : LogOutIcon} />
                    </div>

                    <Typography>Logout</Typography>
                </div>
            </div>
        </Popover>
    );
};
